import { render } from "./CollectionsMenu.vue?vue&type=template&id=52247380&scoped=true"
import script from "./CollectionsMenu.vue?vue&type=script&lang=js"
export * from "./CollectionsMenu.vue?vue&type=script&lang=js"

import "./CollectionsMenu.vue?vue&type=style&index=0&id=52247380&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52247380"]])

export default __exports__